"use strict";
/**
 * @module Services.TopicUpdate
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var BEES = require("./../../serialisers/byte-encoded-enum-serialiser");
var serialiser_1 = require("./../../serialisers/serialiser");
var UpdateConstraintSerialiser = require("./update-constraint-serialiser");
/**
 * Serialiser for {@link CreateUpdateStreamRequest}
 */
var CreateUpdateStreamRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(CreateUpdateStreamRequestSerialiserClass, _super);
    function CreateUpdateStreamRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Write a {@link CreateUpdateStreamRequest} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link CreateUpdateStreamRequest} to be written
     */
    CreateUpdateStreamRequestSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeString(bos, value.path);
        BEES.write(bos, value.topicType);
        UpdateConstraintSerialiser.write(bos, value.constraint);
    };
    return CreateUpdateStreamRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.CreateUpdateStreamRequestSerialiserClass = CreateUpdateStreamRequestSerialiserClass;
/**
 * The {@link CreateUpdateStreamRequestSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.CreateUpdateStreamRequestSerialiser = new CreateUpdateStreamRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-update/create-update-stream-request-serialiser.js
// module id = 1669
// module chunks = 1